module.exports = "/static/js/ffa8e3b9c969be318e9fce9ec86137e9.png";